import React from 'react'

export default function IconsTagOutline({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'

    return (
        <svg
            className={className}
            style={style}
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10.4887 2.15499C10.1762 1.84241 9.75232 1.66675 9.31033 1.66666H3.33366C2.89163 1.66666 2.46771 1.84225 2.15515 2.15481C1.84259 2.46737 1.66699 2.8913 1.66699 3.33332V9.30999C1.66709 9.75198 1.84274 10.1758 2.15533 10.4883L9.40866 17.7417C9.78742 18.118 10.2997 18.3293 10.8337 18.3293C11.3676 18.3293 11.8799 18.118 12.2587 17.7417L17.742 12.2583C18.1184 11.8796 18.3296 11.3673 18.3296 10.8333C18.3296 10.2994 18.1184 9.78708 17.742 9.40832L10.4887 2.15499Z'
                stroke={fillColor}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6.24967 6.66668C6.47979 6.66668 6.66634 6.48013 6.66634 6.25001C6.66634 6.01989 6.47979 5.83334 6.24967 5.83334C6.01956 5.83334 5.83301 6.01989 5.83301 6.25001C5.83301 6.48013 6.01956 6.66668 6.24967 6.66668Z'
                stroke='#323232'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
